import axios from 'axios'
import { message } from 'antd'
import _ from 'lodash'
import common from '../public/common'
// import baseurl from '../public/common'

// axios.defauls.baseURL = "https://api-b2cadmin.vsigo.cn/webadmin/"
// axios.defaults.withCredentials = true
var myAxios = axios.create({baseURL:common.scpUrl})

myAxios.defaults.timeout = 100000
// // axios拦截器
//  axios.interceptors.request.use(config => {
//     config.setHeaders([
//         // 在这里设置请求头与携带token信息
//     ])
//     return config
//  })

myAxios.interceptors.response.use(response => {
  // 在这里你可以判断后台返回数据携带的请求码
  let _keys;
  if (response.data instanceof Object) {
    _keys = Object.keys(response.data);
  };
  if (response.status === 200 || response.status === '200') {
    if (_.get(response, 'data.code') && _.get(response, 'data.code') != 200 && _.get(response, 'data.code') != 'success' && _keys instanceof Array && _keys.includes('data') && _keys.includes('message')) {
      let errorText = _.get(response, 'data.msg') || _.get(response, 'data.message') || _.get(response, 'data.error_msg') || _.get(response, 'data.Message')
      message.error(errorText)
      // return null
      // throw response
      return Promise.reject(response)
    }else{
      return response
    }
  }
})
export default myAxios



// WEBPACK FOOTER //
// ./src/server/http.js